import styled from 'styled-components';
import theme from '../../../styles/theme';

export const EmptyContentText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${theme.colorGray};
  font: normal normal bold 16px 'Calibri';

  span {
    font: normal normal normal 14px 'Calibri';
    letter-spacing: 0.56px;
    margin-top: 6px;
  }
`;

export const ButtonLink = styled.button`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  font-size: 13px;
  font-family: unimed_slabregular;
  color: #00995d;
  border: none;
  background: none;

  &:hover {
    color: #00995d;
    font-weight: bold;
    -webkit-text-decoration: underline;
    text-decoration: underline;
  }
`;
